import { Navigate, Route, Routes } from "react-router"

import { type ComponentType, lazy, type ReactNode, Suspense } from "react"
import HomeLoading from "@/components/loading/HomeLoading"
import Layout from "./layout"

export const RouterProvider = () => {
  const CreateGamePage = lazy(() => import("@app/pages/createGame/page"))
  const MainPage = lazy(() => import("@app/pages/home/page"))
  const GameLayout = lazy(() => import("@app/pages/game/layout"))
  const CustomPage = lazy(() => import("@app/pages/customs/page"))
  const FriendsPage = lazy(() => import("@app/pages/friends/page"))
  const ProfilePage = lazy(() => import("@app/pages/profile/page"))
  const QuestsPage = lazy(() => import("@app/pages/quests/page"))
  const TopPage = lazy(() => import("@app/pages/top/page"))

  return (
    <Suspense fallback={<HomeLoading />}>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<MainPage />} />
          <Route path="friends" element={<FriendsPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="quests" element={<QuestsPage />} />
          <Route path="top" element={<TopPage />} />
          <Route path="customs" element={<CustomPage />} />
        </Route>
        <Route path="/createGame" element={<CreateGamePage />} />
        <Route path="/game" element={<GameLayout />} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Suspense>
  )
}
